import { globalEventManager } from '../event-manager.ts';
import { Logger } from '../../helpers/logger.ts';

interface PostMessageFormat {
    type: string;
    payload: any;
}

export function setupPostMessageBridge(trustedOrigins: string[]): () => void {
    const handleMessage = (event: MessageEvent<PostMessageFormat | any>) => {
        if (!trustedOrigins.includes(event.origin)) {
            return;
        }

        const raw = event.data as any;
        const type = (raw && (raw.id ?? raw.type)) as string | undefined;
        if (!type) {
            return;
        }
        const payload = raw && (raw.payload ?? raw);
        payload.context = determineContextFromSource(event.source);

        const eventName = `postmessage:${type}`;

        globalEventManager.publish(eventName, payload);
    };

    window.addEventListener('message', handleMessage);

    return () => {
        window.removeEventListener('message', handleMessage);
        Logger.info('Listener de PostMessage removido.');
    };
}

const determineContextFromSource = (source: MessageEventSource | null) => {
    const iframes = document.querySelectorAll('iframe');
    const iframe = Array.from(iframes).find(iframe => iframe.contentWindow === source);
    const sourceId = iframe?.getAttribute('name');

    return sourceId || '';

};
